import { getFinancierInstallersDocuments } from 'common/api/financierAllianceInstaller';

import {
    FETCH_REQUIRED_DOCUMENTS_LIST,
    FETCH_REQUIRED_DOCUMENTS_LIST_FAILURE,
    FETCH_REQUIRED_DOCUMENTS_LIST_SUCCESS,
} from '../../actionTypes';
import { installerProfileActions } from '../../reducer';

export default (id) => (dispatch) => {
    dispatch(installerProfileActions[FETCH_REQUIRED_DOCUMENTS_LIST]());

    getFinancierInstallersDocuments(id)
        .then((response) =>
            dispatch(
                installerProfileActions[FETCH_REQUIRED_DOCUMENTS_LIST_SUCCESS](
                    response.data,
                ),
            ),
        )
        .catch((error) =>
            dispatch(
                installerProfileActions[FETCH_REQUIRED_DOCUMENTS_LIST_FAILURE](
                    error?.response?.data?.errors,
                ),
            ),
        );
};
